<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="set-option-dialog"
    width="400px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div
      class="input-form"
    >
      <a-form
        :form="form"
      >
        <add-item-option
          v-for="(item,index) in options"
          :key="item.id"
          :index="index"
          :item="item"
        />
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import AddItemOption from './AddItemOption'
export default {
  components: {
    AddItemOption
  },
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    },
    cloneData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    filtersOptions () {
      this.options.forEach((item) => {
        if (item.isshow) {
          item.isTemp = true
        } else {
          item.isTemp = false
        }
      })
      return this.options
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1198"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
    // this.form.getFieldDecorator('name', { initialValue: [], preserve: false })
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.options.forEach(item => {
            if (item.isTemp) {
              item.isshow = true
            }
            if (item.hasOwnProperty('isTemp')) {
              this.$delete(item, 'isTemp')
              // delete this.item.isTemp
            }
          })
          this.isLimitDialogShow = false
        }
      })
    },
    cancelHandle () {
      this.isLimitDialogShow = false
      this.options.forEach(item => {
        if (item.hasOwnProperty('isTemp')) {
          delete this.item.isTemp
        }
      })
      // this.$set(this.itemData, 'options', this.cloneData.options)
    }
  }
}
</script>

<style lang="scss" scoped>
  .input-form::v-deep {
    margin:11px 20px 11px;
    .ant-checkbox-wrapper {
      margin-bottom: 0;
    }

  }
  </style>
